// Import the functions you need from the SDKs you need
import { auth } from './config';
import { GoogleAuthProvider, signInWithPopup, UserCredential } from 'firebase/auth';
import { CUSTOMER_KEY } from '../../atoms/customerAtom';

// Export auth instance
export { auth };

// Google Sign In
export const signinWithGoogle = async (): Promise<UserCredential> => {
  try {
    // First check if user is already signed in
    if (auth.currentUser) {
      await auth.signOut();
    }
    const provider = new GoogleAuthProvider();
    const result = await signInWithPopup(auth, provider);
    return result;
  } catch (error) {
    console.error('Error signing in with Google:', error);
    throw error;
  }
};

// Centralized Sign Out Function
export const googleSignOut = async (
  setCustomer?: (customer: any) => void,
  handleSignOut?: () => Promise<void>
) => {
  try {
    // 1. Sign out from Firebase using auth context
    if (handleSignOut) {
      await handleSignOut();
    } else {
      await auth.signOut();
    }
    
    // 2. Clear Recoil state if setCustomer is provided
    if (setCustomer) {
      setCustomer(undefined);
    }
    
    // 3. Clear local storage
    localStorage.removeItem(CUSTOMER_KEY);
    
    // 4. Redirect to login
    window.location.href = '#/login';
  } catch (error) {
    console.error('Sign out error:', error);
    throw error;
  }
};